import React from "react";
import { useVelList } from "@/services/useVelList";
import { VelContext } from "@/contexts/VelContext";

interface VelProviderProps {
  children: React.ReactNode;
}

export const VelProvider: React.FC<VelProviderProps> = ({
  children,
}) => {
  const { data, isLoading, isError } = useVelList();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error</div>;
  }

  return (
    <VelContext.Provider value={data}>
      {children}
    </VelContext.Provider>
  );
};
